import React from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Header from "./Header";
import Footer from "./Footer";

/**
 * UserLayout - Main layout wrapper for all user-facing pages
 * Includes Header, Footer, and conditional margin for non-home pages
 */
const UserLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="flex flex-col min-h-screen bg-[#0D0D0D] text-text1">
      <Header />
      <Toaster />
      <main className={`flex-grow ${!isHomePage ? "mt-32 sm:mt-24" : ""}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default UserLayout;
